import { render, staticRenderFns } from "./UserAssignedDid.vue?vue&type=template&id=3b9241b1&scoped=true&"
import script from "./UserAssignedDid.vue?vue&type=script&lang=js&"
export * from "./UserAssignedDid.vue?vue&type=script&lang=js&"
import style0 from "./UserAssignedDid.vue?vue&type=style&index=0&id=3b9241b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9241b1",
  null
  
)

component.options.__file = "UserAssignedDid.vue"
export default component.exports